export default "__VITE_ASSET__Bdl3u3l$__"